var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-address-list',{attrs:{"list":_vm.list,"default-tag-text":"默认"},on:{"add":_vm.onAdd,"edit":_vm.onEdit,"select":_vm.select2back},model:{value:(_vm.chosenAddressId),callback:function ($$v) {_vm.chosenAddressId=$$v},expression:"chosenAddressId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }